
  import { Vue, Component, Prop } from "vue-property-decorator";
  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";
  import { Source } from "@/generated/graphql";
  import DropdownOption from "@/entities/DropdownOption";
  import InputPlaceholder from "@/components/skeletonPlaceholder/components/InputPlaceholder.vue";
  import GET_SOURCES from "@/apollo/source/GetSources.gql";


  @Component({
    components: {
      InputPlaceholder,
      DropdownFilter,
    },
    apollo: {
      sources: {
        query: GET_SOURCES,
        update(data: { source: Source[] }) {
          const sources = data.source;

          this.selectedSource = sources.filter(source => source.id === this.selectedSourceId);
          return sources;
        },
      },
    },
  })
  export default class SourcesMultiselect extends Vue {
    @Prop({ type: String, default: undefined }) selectedSourceId!: string;
    @Prop({ type: String, default: "" }) readonly getcontainerStyle?: string;

    sources: Source[] = [];
    selectedSource: DropdownOption[] = [];

    get sourcesLoaded(): boolean {
      return this.sources.length > 0;
    }

    update(selectedSources: DropdownOption[]): void {
      this.selectedSource = selectedSources;

      if (!selectedSources.length) {
        return;
      }

      this.$emit("input", selectedSources[0].id);
    }
  }
